import classNames from 'classnames'
import Card from 'components/card/card'
import Image from 'components/image'
import { InfoButton } from 'components/buttons'
import { registryChecklistPath } from 'lib/urls'
import css from './feed-items.scss'
import { SectionHeading } from '../../../../components/headings'

interface RegistryChecklistCardProps {
  ctaText: string
  teaser: string
  title: string
}

const RegistryChecklistCard = ({
  ctaText,
  teaser,
  title,
}: RegistryChecklistCardProps) => {
  const checklistIconUrl =
    '//images.babylist.com/image/upload/v1568844788/checklist/checklist_color_1.svg'

  return (
    <Card className={classNames(css.iconLayout, css.registryChecklist, 'mbxl')}>
      <div>
        <Image
          alt="Checklist Icon"
          height={100}
          src={checklistIconUrl}
          width={100}
        />
        <SectionHeading className="h2 mtl mbs text-bold">
          {title}
        </SectionHeading>
        <p className="text-body">{teaser}</p>
        <InfoButton
          className={classNames('mvl phxl', css.fullCardLinkButton)}
          href={registryChecklistPath}
          pill
        >
          {ctaText}
        </InfoButton>
      </div>
    </Card>
  )
}

export default RegistryChecklistCard
